import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';
import { UIStateProps, uiState } from '../../atoms/uiAtom';
import { Wizard, useWizard } from 'react-use-wizard';

import { AxiosResponse } from 'axios';
import Button from '../common/Button';
import { ReactComponent as LetterIcon } from '../../assets/letter.svg';
import Loader from '../common/Loader';
import { ModalResponse } from '../../enum/ModalResponse';
import { createPortal } from 'react-dom';
import { useAuth } from '../../hooks/auth';
import { useExportSdpData } from '../../hooks/sdps';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

export interface ModalExportSdpDataProps extends ModalProps {
  sdpId?: string;
}
interface FooterProps {
  isPending: boolean;
  wrapper: any;
  onClickCancel: () => void;
  asyncAction: () => Promise<AxiosResponse<any, any>>;
}
function Footer({ onClickCancel, asyncAction, wrapper, isPending }: FooterProps) {
  const { t } = useTranslation();
  const setUiState = useSetRecoilState<UIStateProps>(uiState);
  const { nextStep, activeStep } = useWizard();

  const handleClickExport = () => {
    asyncAction()
      .then(() => {
        nextStep();
      })
      .catch(() => {
        onClickCancel();
        setUiState((prev) => ({ ...prev, hasError: true }));
      });
  };
  return wrapper
    ? createPortal(
        <div className="modal__actions">
          {activeStep === 0 ? (
            <Fragment>
              <Button isDisabled={isPending} className="btn btn--secondary" onClick={onClickCancel}>
                {t('common.cancel')}
              </Button>
              <Button
                isDisabled={isPending}
                className="btn btn--primary"
                onClick={handleClickExport}
                prefix={isPending ? <Loader /> : null}
              >
                {t('modal.meter.export.sdp.data.next')}
              </Button>
            </Fragment>
          ) : (
            <Button className="btn btn--primary" onClick={onClickCancel}>
              {t('common.close')}
            </Button>
          )}
        </div>,
        wrapper
      )
    : null;
}
export default function ModalExportSdpData({
  isOpen,
  sdpId,
  onClickAction,
  onClose,
}: ModalExportSdpDataProps) {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);
  const [modalResponse, setModalResponse] = useState<ModalResponse>();
  const { user } = useAuth();
  const { isPending, mutateAsync } = useExportSdpData();

  const handleClickCancel = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClose = (modalResponse: ModalResponse | undefined) => {
    if (onClose) {
      onClose(modalResponse);
    }
  };

  const getHeader = () => {
    return activeStep === 0
      ? t('modal.meter.export.sdp.data.title')
      : t('modal.meter.export.sdp.data.confirm.title');
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  const [wrapperFooter, setWrapperFooter] = useState<any>();

  const handleOpen = () => {
    setWrapperFooter(document.getElementsByClassName('ReactModal__Content')[0]);
  };

  return (
    <Modal isOpen={isOpen} onOpen={handleOpen} onClose={() => handleClose(modalResponse)}>
      <Fragment>
        <Wizard
          onStepChange={handleStepChange}
          header={<h2 className="modal__title">{getHeader()}</h2>}
          footer={
            <Footer
              isPending={isPending}
              asyncAction={() => mutateAsync(sdpId)}
              onClickCancel={handleClickCancel}
              wrapper={wrapperFooter}
            />
          }
        >
          <div>
            <p className="modal__message mb-2">{t('modal.meter.export.sdp.data.message')}</p>
            <p className="modal__message ">
              {t('modal.meter.export.sdp.data.mail.to')}&nbsp;
              <span className=" modal__message--important">{user?.email}</span>
            </p>
          </div>
          <div>
            <p className="modal__message">
              {t('modal.meter.export.sdp.data.mail.to')}&nbsp;
              <span className=" modal__message--important">{user?.email}</span>
            </p>
            <div className="text-center">
              <LetterIcon className="icon icon--large" />
            </div>
            <p className="modal__message">{t('modal.meter.export.sdp.data.confirm.message.two')}</p>
          </div>
        </Wizard>
      </Fragment>
    </Modal>
  );
}
